var map = {
	"./ar.js": 9602,
	"./bn.js": 5645,
	"./de.js": 9150,
	"./en.js": 8722,
	"./es.js": 7685,
	"./fr.js": 7885,
	"./id.js": 316,
	"./man.js": 7161,
	"./pt.js": 9441,
	"./ru.js": 7276,
	"./st.js": 6230,
	"./sw.js": 3347,
	"./th.js": 9689,
	"./zh.js": 3079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2864;